import Vue from 'vue'
import SvgImage from '~/components/General/SvgImage.vue';

Vue.component('svg-image', SvgImage)